export enum ReturnCode {

  //--- Translated ---//
  ShcedulerInsertOverlapping = 454,
  ShcedulerEventMasterNotFound = 457,
  SchedulerFormatNotSupported = 458,
  /** Catch-all "UpdateEventFailed" from sch/events/update */
  ScheduleUpdateEventFailed = 459,
  ShcedulerUpdateOverlapping = 463,
  ShcedulerDeployOverlapping = 467,
  ScheduleSpecialEventAlreadyScheduled = 481,
  CopyEventExistAtLeastOneEvent = 476,
  EventsAlreadyScheduledInSelectedDates = 477,
  BulkChangestFailed = 478,
  ApplyTemplateFailed = 479,
  AutoScheduleFailed = 480,
  ScheduleUpdateVenueFailed = 483,
  ScheduleUpdateVenueSeatPlanFailed = 484,
  ScheduleSwapVenueFailed = 485,
  ScheduleSwapNoneEventWasFound = 486,
  CopyMultiSitesFailed = 487,
  ScheduleUpdateEMOrDateTimeOfEventFailed = 489,
  ScheduleDeployNotPermitted = 490,
  SchedulePlanningModeNotPermitted = 491,
  ScheduleCancelEvent = 492,
  ScheduleEventHasSales = 493,
  TicketGroupNotFound = 495,
  ScheduleEventSequenceIsNotUnique= 499,
  TicketSwapQTYIsNotSame = 511,
  TicketSwapIsNotSame = 513,
  ScheduleUpdateVenueFailedSoldExisted= 550,
  ScheduleUpdateVenueFailedAllocatedExisted= 551,
  ScheduleUpdateEventFailedDeallocation= 552,
  ScheduleCancelEventNoPermission = 553,
  NoSeatsAvailable = 8001,
  PermissionDeniedSeatSwap = 22001,
  AnotherShoppingCartLocksSvReference = 12191,
  AnotherShoppingCartLocksReservation = 12192,

  //--- End Translated ---//




  SeatsNotSelected = 800,
  SeatNotLocked = 801,
  SeatLockedExpired = 802,
  SeatLockedByOtherUser = 803,
  SeatNotAvailable = 804,
  SeatIsAllocated = 805,
  NoAvailableSeats = 8001,





  Failed = -1,
  Success = 0,
  PermissionDenied = 1,
  UserNotLoggedIn = 2,
  OverrideUserNotLoggedIn = 3,
  CantAccessCDPinOfflineMode = 4,
  InputValidationError = 10,
  InsufficientFunds = 902,
  PaymentCantReturnChange = 101,
  PaymentDontSupportPartialPayment = 102,
  NoOverpayOnNegBal = 10705,
  ShoppingCartDataIsEmpty = 200,
  ShoppingCartCantRemoveItem = 201,
  DiscountAlreadyInShoppingCart = 202,
  CDPTokenExpired = 203,
  PaymentTypeNotSupported = 204,
  PaymentParametersNotConfiguredCorrectly = 205,
  PaymentAmountIsMissing = 206,
  ReservationAlreadyLoaded = 207,
  TicketAlreadyLoaded = 208,
  ExpirationDateIsInvalid = 209,
  ShoppingCartCantRemoveItemPaymentExists = 210,



  PaymentNotFound = 300,
  TicketNotFound = 301,
  EventNotFound = 302,
  EventMasterNotFound = 303,
  MembershipNotFound = 304,
  MembershipSummaryNotFound = 305,
  StoredValueNotFound = 306,
  StoredValueDetailNotFound = 307,
  ProductNotFound = 308,
  SellableNotFound = 309,
  ProductOrSellableNotFound = 310,
  ShoppingCartItemNotFound = 311,
  SystemInquiryNotFound = 312,
  SystemInquiryChoiceNotFound = 313,
  CustomerNotFound = 314,
  SystemValidationNotFound = 315,
  DiscountNotFound = 316,
  PaymentsInTicketNotFound = 317,
  StoredValueSummaryNotFound = 318,
  SellableInStoredValueNotFound = 319,
  CustomerServiceItemNotFound = 320,
  StoredValueSummaryFound = 321,
  StoredValueSummaryDetailsNotFound = 322,
  StoredValueTypeNotFound = 322,
  ReservationNotFound = 323,
  MembershipSchemeNotFound = 324,
  SellableInMembershipNotFound = 325,
  MembershipSummaryFound = 326,
  MembershipLevelNotFound = 327,
  VenueNotFound = 328,
  VenueSeatPlanNotFound = 329,
  VenueSectionNotFound = 330,
  VenueSectionSeatNotFound = 331,
  SiteNotFound = 332,
  PosNotFound = 333,
  TicketSaleExpiredEvent = 334,
  TicketSaleFutureEvent = 335,
  TicketSaleEventNotAvailable = 336,
  SaleChannelNotFound = 337,
  CustomerTokenExpired = 338,
  CustomerLoginInvalidCredentials = 339,
  CustomerLoginLocked = 340,
  ProductModifierClassNotFound = 341,

  StoredValueExistedDuplicateReference = 342,
  StoredValueBulkSaleFailed = 343,
  StoredValueReferenceNotExisted = 344,
  StoredValueBulkRemoveFailed = 345,
  StoredValueBulkSaleReferenceMissed = 346,
  EventInSaleChannelNotFound = 347,
  TicketSaleEventInSaleChannelNotAvailable = 348,
  TicketSaleInVenueSectionNotAvailable = 349,
  CustomerPasswordPolicyFailed = 350,

  SystemValidationBeforeTime = 400,
  SystemValidationAfterTime = 401,
  SystemValidationBeforeDateTime = 402,
  SystemValidationAfterDateTime = 403,
  SystemValidationNotValidOnSunday = 404,
  SystemValidationNotValidOnMonday = 405,
  SystemValidationNotValidOnTuesday = 406,
  SystemValidationNotValidOnWednesday = 407,
  SystemValidationNotValidOnThursday = 408,
  SystemValidationNotValidOnFriday = 409,
  SystemValidationNotValidOnSaturday = 410,

  TicketMinimumQuantity = 500,
  TicketMaximumQuantity = 501,
  TicketMaximumQuantityGlobal = 502,
  TicketMaximumQuantityPerBusinessDate = 503,
  TicketMaximumQuantityPerEventDate = 504,
  TicketMaximumQuantityInEvent = 505,
  TicketMinimumQuantityInEvent = 506,
  TicketMaximumQuantityPerEventMaster = 507,
  TicketMaximumQuantityInEventForPercentage = 508,
  TicketIsSoldOnSpecialEngagement = 509,
  TicketIsValidatePaymentInTicket = 510,
  TicketSwapSrcEventNotFound = 512,

  ProductMinimumQuantity = 530,
  ProductMaximumQuantity = 531,
  ProductModifierMandatoryClassNotSelected = 532,
  ProductModifierClassMinimumQuantityNotReached = 532,
  ProductModifierClassMaximumQuantityReached = 532,
  ProductNotInSaleChannel = 533,

  // ApplyTemplateFailed = 570,

  StoredValueCantRefundMaxBalance = 601,
  StoredValueRedemptionCantRedeem = 602,
  StoredValuePromotionBalanceExeption = 603,
  StoredValuePromotionCardCheckExeption = 604,
  StoredValuePromotionChargeExeption = 605,
  StoredValuePromotionChargeAmountExeption = 606,
  StoredValuePromotionCancelTransactionExeption = 607,
  StoredValuePromotionCardMissing = 608,
  StoredValuePromotionParsingParameterExeption = 609,
  StoredValueAlreadyInShoppingCart = 610,
  StoredValueRedemptionCantRedeemInsufficientBalance = 611,
  StoredValuePromotionProviderNotFound = 612,
  StoredValueCantRedeemProductIsNotInShoppingCart = 613,
  StoredValueCantRedeemTicketIsNotInShoppingCart = 614,
  StoredValueCantRedeemSellableIsNotInShoppingCart = 615,
  StoredValueCantRedeemProductNotFound = 616,
  StoredValueCantRedeemTicketNotFound = 617,
  StoredValueCantRedeemSellableNotFound = 618,

  SiteCodeIsMissing = 701,
  StoredValueSiteNotAllowed = 702,

  TicketCodeIsMissing = 710,
  StoredValueTicketNotAllowed = 711,





  MembershipCantRedeemMoreThenOnePerEvent = 900,
  MembershipMaximumTicketsPerDay = 901,
  MembershipMaximumTicketsPerTransaction = 902,
  MembershipMaximumAdvanceTickets = 903,
  MembershipMaximumAmountPerDay = 904,
  MembershipMaximumAmountPerWeek = 905,
  MembershipMaximumPointsPerDay = 906,
  MembershipMaximumPointsPerWeek = 907,
  MembershipCodeMismatch = 908,
  MembershipFieldsEmpty = 909,
  MembershipFieldsInvalidEmail = 910,
  MembershipFieldsIsRequired = 911,
  MembershipFieldsInvalidMobilePhone = 912,
  MembershipFieldsInvalidLength = 913,
  MembershipFieldsEmailAlreadyExists = 914,
  MembershipFieldsInvalidPicture = 915,
  MembershipFieldsInvalidDOB = 916,
  MembershipFieldsIsNotUpdatable = 917,


}

